import { React } from 'react'
import { useTranslation } from 'react-i18next'
import { Expander, ExpanderHeader, ExpanderContent, ResponsiveTableRow, H5 } from '@fs/zion-ui'
import { DmcResponsiveTable } from '../../common/DmcResponsiveTable'

// Creates a basic table of the raw artifact, with one key-value pair per row
export default function RawArtifactDataPanel({ artifact }) {
  const [t] = useTranslation()
  const title = t('artifacts.rawArtifactData', 'Raw Artifact Data')
  const keys = Object.keys(artifact).sort()
  const columnHeaders = ['', ' ']
  const responsiveTableRows = keys.map((key) => {
    let value = artifact[key]
    // Give URLs, booleans, and arrays special treatment
    if (typeof value === 'string' && key.toLowerCase().includes('url')) {
      value = (
        <a href={artifact[key]} target="_blank" rel="noopener noreferrer">
          {artifact[key]}
        </a>
      )
    } else if (Array.isArray(value)) {
      value = value.join(', ')
    } else if (value === null) {
      value = ''
    } else {
      // Pushing a bool or other types directly into JSX won’t display
      value = String(value)
    }
    const object = {}
    object[key] = value
    return <ResponsiveTableRow key={key} column1={key} column2={value} />
  })

  return (
    <Expander>
      <ExpanderHeader>
        <H5>{title}</H5>
      </ExpanderHeader>
      <ExpanderContent>
        <DmcResponsiveTable
          totalColumnCount={columnHeaders.length}
          atSizeColumns={{
            default: {
              labels: columnHeaders,
            },
          }}
          separator={<br />}
        >
          {responsiveTableRows}
        </DmcResponsiveTable>
      </ExpanderContent>
    </Expander>
  )
}
